/**
 * Преобразует строку даты в метку времени
 * @example "14.07.2020" => 1594684800000
 */
export const dateStringToTimestamp = (dateString: string) => {
  const dayMonthYear = dateString.split('.').map((i) => parseInt(i, 10));
  dayMonthYear[1] -= 1;
  return new Date(dayMonthYear[2], dayMonthYear[1], dayMonthYear[0]).getTime();
};
